import _slicedToArray from "C:\\BuildCode\\Frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\BuildCode\\Frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "C:\\BuildCode\\Frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\BuildCode\\Frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import e, { createContext as t } from "react";
var r = function r() {
    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }
    var t = Object.assign.apply(Object, [{}].concat(e));
    var r;
    return Object.keys(t).reduce(function (e, n) {
      var o = Object.keys(t[n]);
      if (r || (r = o), JSON.stringify(r.sort()) !== JSON.stringify(o.sort())) throw new Error("Wrong amount of languages, expected '".concat(r, "' but got '").concat(o, "'"));
      return _objectSpread({}, e, _defineProperty({}, n, r.reduce(function (e, r) {
        var o = t[n][r];
        if (o && o.normalized) return _objectSpread({}, e, _defineProperty({}, r, o));
        if ("function" == typeof o) {
          var _t = function _t() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return o(e);
          };
          return _t.normalized = !0, _objectSpread({}, e, _defineProperty({}, r, _t));
        }
        if ("string" == typeof o) {
          var _t2 = function _t2() {
            return o;
          };
          return _t2.normalized = !0, _objectSpread({}, e, _defineProperty({}, r, _t2));
        }
        throw new Error("Value cannot be of type \"".concat(typeof o, "\""));
      }, {})));
    }, {});
  },
  n = function n(_ref) {
    var e = _ref.id,
      t = _ref.dictionary,
      r = _ref.language,
      n = _objectWithoutProperties(_ref, ["id", "dictionary", "language"]);
    if (!e) {
      var _t3 = Object.entries(n).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          e = _ref3[0],
          t = _ref3[1];
        return "boolean" == typeof t;
      }).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 1),
          e = _ref5[0];
        return e;
      });
      if (!_t3.length) throw new Error("Please make sure to pass an id");
      if (_t3.length > 1) throw new Error("Please only pass a single id/boolean, detected '".concat(_t3, "'"));
      e = _t3[0];
    }
    var o = Object.keys(t);
    if (!o.includes(e)) throw new Error("Couldn't find '".concat(e, "' in the dictionary. Available ids: ").concat(o));
    if (void 0 === t[e][r]) throw new Error("The language '".concat(r, "' is not available (attempted with id '").concat(e, "')"));
    return t[e][r](n);
  };
var _t4 = t({}),
  o = _t4.Provider,
  i = _t4.Consumer;
var a = function a(_ref6) {
  var e = _ref6.children;
  return e;
};
if ("undefined" != typeof require) try {
  a = require("react-native").Text;
} catch (e) {}
export default (function (_ref7) {
  var t = _ref7.language,
    _ref7$dictionary = _ref7.dictionary,
    l = _ref7$dictionary === void 0 ? {} : _ref7$dictionary,
    c = _ref7.children,
    s = _ref7.render,
    u = _ref7.component,
    d = _objectWithoutProperties(_ref7, ["language", "dictionary", "children", "render", "component"]);
  return e.createElement(i, null, function (i) {
    return c ? (t = t || i.language, l = _objectSpread({}, i.dictionary, r(l)), e.createElement(o, {
      value: {
        language: t,
        dictionary: l
      }
    }, c)) : u ? !0 === d[i.language] ? u : null : s ? s(n(_objectSpread({}, i, d))) : e.createElement(a, null, n(_objectSpread({}, i, d)));
  });
});